// Lightweight API client for lead submissions.
import { buildMeta } from "./utm";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

async function postLead(path, body) {
  const meta = buildMeta();
  const payload = { ...meta, ...body };
  // Strip undefined / empty strings except honeypot fields. We keep BOTH the
  // legacy `_company_website` (older cached bundles) and the new `_hp_check`
  // so the backend can see a non-empty honeypot regardless of which bundle
  // is in the user's browser cache.
  Object.keys(payload).forEach((k) => {
    if (k === "_company_website" || k === "_hp_check") return;
    if (payload[k] === "" || payload[k] === undefined) delete payload[k];
  });
  let res;
  try {
    res = await fetch(`${API}/leads/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    return {
      ok: false,
      status: 0,
      code: "network_error",
      message: "Network error. Please check your connection and try again.",
    };
  }

  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = {};
  }

  if (!res.ok) {
    const detail = data && data.detail;
    let code, message;
    if (Array.isArray(detail)) {
      code = "validation_error";
      message = detail
        .map((d) => `${(d.loc || []).slice(-1)[0] || "field"}: ${d.msg}`)
        .join(" • ");
    } else if (typeof detail === "object" && detail) {
      code = detail.code || "error";
      message = detail.message || "Submission failed.";
    } else {
      code = "error";
      message = data.message || `Request failed (${res.status}).`;
    }
    return { ok: false, status: res.status, code, message, raw: data };
  }
  return { ok: true, status: res.status, ...data };
}

export const submitQuickLead = (body) => postLead("quick", body);
export const submitQuoteLead = (body) => postLead("quote", body);
export const submitContactLead = (body) => postLead("contact", body);
